import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import GameEvent from "../../../core/application/GameEvent";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTDialogFactory from "../../../ngt/dialog/NGTDialogFactory";
import NGTDialogPlayerEvent from "../../../ngt/dialog/NGTDialogPlayerEvent";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import AppNGTDialogPlayer from "../../dialog/view/AppNGTDialogPlayer";
import HubEvent from "../../hub/event/HubEvent";

export default class PlayConversationStatementCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AppNGTDialogPlayer} dialogPlayer 
     * @param {NGTDialogFactory} dialogFactory 
     */
    constructor(dispatcher, dialogPlayer, dialogFactory) {
        super(dispatcher);

        this._dialogPlayer = dialogPlayer;
        this._dialogFactory = dialogFactory;
    }

    execute(evt) {
        this.dispatch(GameEvent.PAUSE_GAME);
        this.dispatch(HubEvent.HIDE_HUB);

        const data = evt.params.data;

        /** @type {MeetingNotesContent} */
        const content = data.content;
        const contentPlayer = data.contentPlayer;

        this._dialogPlayer.setContentPlayer(contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getLocationID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        this._screenSkin = this.openPopup(SkinKeyRegistry.CONVERSATION_STATEMENT_SCREEN_SKIN, null, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
            priority: 10,
            needsOverlay: false,
        }, {
            dialogPlayer: this._dialogPlayer,
        });

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._handleContentCompletedBound);

        this._dialogPlayer.viewContent();
    }

    destroy() {
        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._handleContentCompletedBound);

        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
    }

    _handleContentCompleted(evt) {
        if (evt.params.contentPlayer !== this._dialogPlayer) {
            return;
        }

        this._dispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._handleContentCompletedBound);

        this.closePopup(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this.dispatch(GameEvent.RESUME_GAME);
        this.dispatch(HubEvent.SHOW_HUB);

        this.destroy();
    }
}